import React from 'react'

const Services = () => {
  return (
    <div className="content-page">Services</div>
  )
}

export default Services